import type { ApiTotal, CalcPayload } from '@/common/types';

export function useCalcTotal() {
	const totalRes = ref<ApiTotal>();
	const autoRes = ref<ApiTotal>();
	const aviaRes = ref<ApiTotal>();

	const defaultValues: ApiTotal = {
		result_cny: '0',
		result_rub: '0',
		summary_weight: 0,
		summary_weight_cost: '0',
		ensurance_cost: 0,
		cargos_detailed: [
			{
				volume: 0,
				total_volume: 0,
				price_cny: '0',
				total_price_cny: '0',
				quantity: 0
			}
		]
	};

	async function postCalcOtherType(payload: CalcPayload) {
		try {
			autoRes.value = undefined;
			aviaRes.value = undefined;

			const runtimeConfig = useRuntimeConfig();
			const [avia, auto] = await Promise.allSettled(
				['avia', 'auto'].map((delT) => {
					return $fetch<ApiTotal>('/calculate_price/', {
						baseURL: runtimeConfig.public.CARGO_API_URL,
						method: 'POST',
						body: {
							...payload,
							type: delT
						}
					});
				})
			);

			autoRes.value =
				auto.status === 'fulfilled' ? auto.value : undefined;

			aviaRes.value =
				avia.status === 'fulfilled' ? avia.value : undefined;
		} catch (e) {
			console.error(e);
		}
	}

	async function postCalcPrice(payload: CalcPayload) {
		try {
			const runtimeConfig = useRuntimeConfig();

			const res = await $fetch<ApiTotal>('/calculate_price/', {
				baseURL: runtimeConfig.public.CARGO_API_URL,
				method: 'POST',
				body: payload
			});

			totalRes.value = res ?? defaultValues;
			postCalcOtherType(payload);
		} catch (e) {
			console.error(e);
			totalRes.value = defaultValues;
		}
	}

	return { postCalcPrice, totalRes, autoRes, aviaRes };
}
